/** Máscara exibida no lugar de valores em dinheiro para não-admins
 *  (Rankings e Histórico — mesma constante do app original). */
export const MASKED_BRL = "R$ ••••";

export function formatBRL(value: number): string {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
  });
}

/** Datas de torneio são UTC-midnight — sempre exibir em UTC para não
 *  retroceder um dia no fuso do Brasil (gotcha herdado do app original). */
export function formatDateUTC(iso: string): string {
  return new Date(iso).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    timeZone: "UTC",
  });
}

export function formatDateRangeUTC(startIso: string, endIso: string): string {
  return `${formatDateUTC(startIso)} — ${formatDateUTC(endIso)}`;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Countdown até o deadline — port de timeRemaining do lib/finance.ts
 *  original: "2d 3h", "3h 12m", "45m" ou "Apostas encerradas". */
export function timeRemaining(iso: string): string {
  const target = new Date(iso).getTime();
  if (Number.isNaN(target)) return "Apostas encerradas";
  const diff = target - Date.now();
  if (diff <= 0) return "Apostas encerradas";
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}

/** Deadline de palpites: mesmo formato de data dos cards de torneio
 *  ("16 de jul.") + hora local do corte — ex.: "16 de jul., 20:50". */
export function formatDeadline(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
